import React, { useEffect, useReducer } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native'
import PropTypes from 'prop-types'

const INPUT_CHANGE = 'INPUT_CHANGE'
const INPUT_BLUR = 'INPUT_BLUR'
const inputReducer = (state, action) => {
  //console.log('action in input.js')
  //console.log(action)
  switch (action.type) {
    case INPUT_CHANGE:
      return {
        ...state,
        value: action.value,
        isValid: action.isValid,
        isTouched: true,
      }
    case INPUT_BLUR:
      //console.log('in input blur reducer')
      return {
        ...state,
        isTouched: true,
      }
    default:
      //console.log('else')
      return state
  }
  //console.log(state)
}

const Input = (props) => {
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: props.initialValue ? props.initialValue : '',
    isValid: props.initiallyValid,
    isTouched: false,
  })
  // console.log('init state')
  // console.log(inputState)
  const { onInputChange, id } = props

  const lostFocusHandler = () => {
    // console.log('lancement dispacth INPUT_BLUR')
    dispatch({ type: INPUT_BLUR })
  }

  useEffect(() => {
    // console.log('use effect')
    if (inputState.isTouched) {
      //  console.log('lancement onInputChange')
      onInputChange(id, inputState.value, inputState.isValid)
    }
  }, [inputState, onInputChange, id])

  const textChangeHandler = (text) => {
    // console.log('textchange')
    // console.log(props)
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let isValid = true
    if (props.required && text.trim().length === 0) {
      isValid = false
    }
    if (props.email && !emailRegex.test(text.toLowerCase())) {
      isValid = false
    }
    if (props.min != null && +text < props.min) {
      isValid = false
    }
    if (props.max != null && +text > props.max) {
      isValid = false
    }
    if (props.minLength != null && text.length < props.minLength) {
      isValid = false
    }
    dispatch({ type: INPUT_CHANGE, value: text, isValid: isValid })
  }
  //console.log(inputState)
  return (
    <View style={styles.formControl}>
      <Text style={styles.label}>{props.label}</Text>
      <TextInput
        {...props}
        style={styles.input}
        value={inputState.value}
        onChangeText={(text) => textChangeHandler(text)}
        onBlur={lostFocusHandler}
        placeholder={props.placeHolder}
        multiline={props.multiline}
      />
      {!inputState.isValid && inputState.isTouched && (
        <View style={styles.errorContainer}>
          <Text style={styles.errorText}>{props.errorText}</Text>
        </View>
      )}
    </View>
  )
}

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
  required: PropTypes.bool,
  email: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  minLength: PropTypes.number,
  onInputChange: PropTypes.func,
  initialValue: PropTypes.string,
  initiallyValid: PropTypes.bool,
  placeHolder: PropTypes.string,
  multiline: PropTypes.bool,
}
export default Input

const styles = StyleSheet.create({
  formControl: {
    width: '100%',
  },
  label: {
    //fontFamily: 'josefin-sans-bold',
    marginVertical: 8,
  },
  input: {
    paddingHorizontal: 2,
    paddingVertical: 5,
    borderBottomColor: '#ccc',
    borderBottomWidth: 1,
    backgroundColor: 'white',
    borderRadius: 5,
  },
  errorContainer: {
    marginVertical: 5,
  },
  errorText: {
    //fontFamily: 'josefin-sans',
    color: 'red',
    fontSize: 13,
  },
})
